import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    testPaperListLoading: false,
    testPaperListSuccess: null,
    testPaperListError: '',

    getTestPaperLoading: false,
    getTestPaperSuccess: null,
    getTestPaperError: '',

    createTestPaperLoading: false,
    createTestPaperSuccess: {},
    createTestPaperError: '',
}

export const testPaperSlice = createSlice({
    name: 'TestPaper',
    initialState, 
    reducers: {
        setTestPaperListLoading: (state) => {
            state.testPaperListLoading = true;
            state.testPaperListSuccess = null;
            state.testPaperListError = '';
        },
        setTestPaperListSuccess: (state, action) => {
            state.testPaperListLoading = false;
            state.testPaperListSuccess = action.payload;
            state.testPaperListError = '';
        },
        setTestPaperListError: (state, action) => {
            state.testPaperListLoading = false;
            state.testPaperListSuccess = null;
            state.testPaperListError = action.payload;
        },
        setGetTestPaperLoading: (state) => {
            state.getTestPaperLoading = true;
            state.getTestPaperSuccess = {};
            state.getTestPaperError = '';
        },
        setGetTestPaperSuccess: (state, action) => {
            state.getTestPaperLoading = false;
            state.getTestPaperSuccess = action.payload;
            state.getTestPaperError = '';
        },
        setGetTestPaperError: (state, action) => {
            state.getTestPaperLoading = false;
            state.getTestPaperSuccess = {};
            state.getTestPaperError = action.payload;
        },
        setCreateTestPaperLoading: (state) => {
            state.createTestPaperLoading = true;
            state.createTestPaperSuccess = {};
            state.createTestPaperError = '';
        },
        setCreateTestPaperSuccess: (state, action) => {
            state.createTestPaperLoading = false;
            state.createTestPaperSuccess = action.payload;
            state.createTestPaperError = '';
        },
        setCreateTestPaperError: (state, action) => {
            state.createTestPaperLoading = false;
            state.createTestPaperSuccess = {};
            state.createTestPaperError = action.payload;
        },
        resetTestPaperDetails: (state) => {
            state.getTestPaperSuccess = {};
            state.createTestPaperSuccess = {};
        },
    }
})

export const { setTestPaperListLoading, setTestPaperListSuccess, setTestPaperListError,
    setGetTestPaperLoading, setGetTestPaperSuccess, setGetTestPaperError, 
    setCreateTestPaperLoading, setCreateTestPaperSuccess, setCreateTestPaperError, 
    resetTestPaperDetails
} = testPaperSlice.actions;


export default testPaperSlice.reducer;